import { useMutation } from "@tanstack/react-query";
import myAxios from "@/utilize/MyAxios.ts";

export type TNewRole = {
  name: string;
  description: string;
  permissions?: string[];
};

export default function useCreateRole() {
  return useMutation({
    mutationFn: (payload: TNewRole) =>
      myAxios.post("acl/custom-role", payload).then((res) => res.data),
  });
}
